export const wintradoHomeUrl = 'https://www.wintrado.com';
